module.exports = __webpack_public_path__ + "static/media/img04.8436e3ae.webp";